import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=5d2b9e7b&scoped=true"
import script from "./Selector.vue?vue&type=script&lang=js"
export * from "./Selector.vue?vue&type=script&lang=js"
import style0 from "./Selector.vue?vue&type=style&index=0&id=5d2b9e7b&prod&lang=less&scoped=true"
import style1 from "./Selector.vue?vue&type=style&index=1&id=5d2b9e7b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2b9e7b",
  null
  
)

export default component.exports